<template>
  <div class="summary-container">
    <div class="summary-card">
      <p class="summary-title">
        {{ $t('TEMPLATE_EVENTS_REPORT.SUMMARY.TOTAL_MESSAGES') }}
      </p>
      <p class="summary-value">{{ totalMessages.toLocaleString() }}</p>
    </div>
    <div class="summary-card">
      <p class="summary-title">
        {{ $t('TEMPLATE_EVENTS_REPORT.SUMMARY.UNIQUE_TEMPLATES') }}
      </p>
      <p class="summary-value">{{ uniqueTemplates.length }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemplateEventsSummary',
  props: {
    events: {
      type: Array,
      required: true,
    },
  },
  computed: {
    totalMessages() {
      return this.events.length;
    },
    uniqueTemplates() {
      const names = this.events
        .map(e => e.template_name)
        .filter(name => !!name);
      return [...new Set(names)];
    },
  },
};
</script>

<style scoped>
.summary-container {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.summary-card {
  background-color: #e0e0e0;
  border-radius: 10px;
  padding: 20px 24px;
  min-width: 180px;
  flex: 0 0 auto;
}

.summary-title {
  font-size: 14px;
  color: #555;
  margin-bottom: 8px;
}

.summary-value {
  font-size: 24px;
  font-weight: bold;
  color: #222;
}
</style>
